import { View, StyleSheet } from "react-native";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signOut, startupProcess } from "./actions";
import ProductList from "./components/Home/ProductList";
import { colors } from "./constants/styles";
import Filters from "./components/Home/Filters";
import Basket from "./components/Home/Basket";
import QuantityModifier from "./components/Home/QuantityModifier";
import { addToBasketAsync } from "./actions/options";
import { Dispatch } from "redux";
import { AddToBasketAsyncAction } from "./types/option";
import { StartupProcesAction } from "./types/general";
import Settings from "./containers/Settings/index";
import { getSelectedFilter, getEnableCombosForTpos } from "./selectors/config";
import { SETTINGS } from "./constants/menuItem";
import ComboModal from "./components/Home/ComboModal";
import { Product } from "./types/product";
import { SelectedComboChoices } from "./types/combo-type";
import { SignoutActionType } from "./types/action-types";
import { TposBasketContext } from "./contexts";
import { useOrderDetailsToggle } from "./hooks/useOrderDetailsToggle";
import { usePrinterConnectionPolling } from "./hooks/usePrinterConnectionPolling";

export default function Home() {
  const dispatch =
    useDispatch<
      Dispatch<AddToBasketAsyncAction | StartupProcesAction | SignoutActionType>
    >();
  const [quantity, setQuantity] = useState(1);
  const [selectedBasketItem] = useState();
  const [comboProduct, setComboProduct] = useState<Product | null>(null);
  const { selectedOrder, setOrder, clearOrder } = useOrderDetailsToggle();

  const selectedFilter = useSelector(getSelectedFilter);
  const enableCombosForTpos = useSelector(getEnableCombosForTpos);
  usePrinterConnectionPolling();

  useEffect(() => {
    dispatch(startupProcess());
  }, [dispatch]);

  return (
    <TposBasketContext.Provider
      value={{ selectedBasketItem, selectedOrder, setOrder, clearOrder }}
    >
      <View style={styles.container} testID="container">
        <Filters />
        <View style={styles.homeContainer} testID="homeContainer">
          <View
            testID="quantitySelectContainer"
            style={styles.quantitySelectContainer}
          >
            <QuantityModifier quantity={quantity} setQuantity={setQuantity} />
          </View>
          <View style={styles.basketContainer} testID="basketContainer">
            <Basket />
          </View>
          <View style={styles.menuContainer} testID="menuContainer">
            {selectedFilter === SETTINGS ? (
              <Settings
                onLogoutPress={() => {
                  dispatch(signOut());
                }}
              />
            ) : (
              <ProductList
                onItemPress={(item, isCombo) => {
                  if (enableCombosForTpos && isCombo) {
                    setComboProduct(item);
                  } else {
                    dispatch(
                      addToBasketAsync({
                        item,
                        quantity,
                      }),
                    );
                    setQuantity(1);
                  }
                }}
              />
            )}
          </View>
        </View>
      </View>
      {comboProduct && (
        <ComboModal
          visible
          product={comboProduct}
          quantity={quantity}
          setQuantity={setQuantity}
          onClose={() => setComboProduct(null)}
          onAddToOrder={(
            item: Product,
            qty: number,
            comboSelections: Record<number, SelectedComboChoices[]>,
          ) => {
            dispatch(
              addToBasketAsync({ item, quantity: qty, comboSelections }),
            );
            setComboProduct(null);
            setQuantity(1);
          }}
        />
      )}
    </TposBasketContext.Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.cardBackgroundWhite,
  },
  homeContainer: {
    flex: 1,
    flexDirection: "row",
    marginHorizontal: 10,
  },
  quantitySelectContainer: {
    flex: 1,
  },
  basketContainer: {
    flex: 5,
    padding: 10,
  },
  menuContainer: {
    flex: 9,
  },
});
